export const IHighlightManager = Symbol.for('IHighlightManager');
export const ISelectionManager = Symbol.for('ISelectionManager');
export const IStateActionManager = Symbol.for('IStateActionManager');
export const IRedoUndoManager = Symbol.for('IRedoUndoManager');
export const IImageManager = Symbol.for('IImageManager');
export const IAnimationManager = Symbol.for('IAnimationManager');
export const IPaneManager = Symbol.for('IPaneManager');
export const IModeManager = Symbol.for('IModeManager');
export const IGlobalConstManager = Symbol.for('IGlobalConstManager');
export const IInjector = Symbol.for('IInjector');
export const ILogger = Symbol.for('ILogger');
export const IRendererManager = Symbol.for('IRendererManager');
export const IWikMap = Symbol.for('IWikMap');

export default {
  IHighlightManager,
  ISelectionManager,
  IStateActionManager,
  IRedoUndoManager,
  IImageManager,
  IAnimationManager,
  IPaneManager,
  IModeManager,
  IGlobalConstManager,
  IInjector,
  ILogger,
  IRendererManager,
  IWikMap,
};
